const videoSections = document.getElementsByClassName("video-section");

function playVideo(videoItem) {

    videoItem.querySelector("#play-button").addEventListener('click', function(){

        const video = videoItem.querySelector('video');

        if(video.paused) {
            video.play();
            this.querySelectorAll(".play-button__play")[0].style.display= 'none';
            this.querySelectorAll(".play-button__pause")[0].style.display= 'block';
        }
        else {
            video.pause();
            this.querySelectorAll(".play-button__play")[0].style.display= 'block';
            this.querySelectorAll(".play-button__pause")[0].style.display= 'none';
        }
    });
};

for(const item of videoSections) {
    playVideo(item);
};


    
 

